import React, { useEffect } from 'react';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import Input from '../../../../components/elements/form/input';
import Teaxtarea from '../../../../components/elements/form/textarea';
import SelectBox from '../../../../components/elements/form/selectBox';
import { DropdownOptionType, Option } from '../../../../_config/types';
import Datepicker from '../../../../components/elements/form/datepicker';
import Button from '../../../../components/elements/button';
import { AgGridReact } from 'ag-grid-react';
import FileUpload from '../../../../components/elements/form/fileUplaod';
import CreateReceiptParts from './createReceiptParts';
import CreateReceiptAssets from './createReceiptAssets';
import { useCommonApi } from '../../../../store/api/hooks/commonApiHook';
import { useAssetsApi } from '../../../../store/api/hooks/assetsApiHook';
import { useFacilitiesApi } from '../../../../store/api/hooks/facilitiesApiHook';
import { usePurchaseOrderApi } from '../../../../store/api/hooks/purchaseOrderApiHook';
import Currency from '../../../../components/currency';
import { useReceiptApi } from '../../../../store/api/hooks/receiptApiHook';
import toast from 'react-hot-toast';
import { useUserSelector } from '../../../../store/selectors/userSelector';
import moment from 'moment';
import Loader from '../../../../components/loader';

interface CreateReceiptProps {
    po?: any;
    onCreate?: () => void;
    onCancel?: () => void;
}

type FormValues = {
    purchaseOrderID: DropdownOptionType;
    purchaseOrderCode: string;
    facilityID: DropdownOptionType;
    notes: string;
    receiptFiles: any;
};


const CreateFacilities: React.FC<CreateReceiptProps> = ({ po = null, onCreate = () => { }, onCancel = () => { } }) => {
    const { control, register, handleSubmit, formState: { errors }, watch, setValue } = useForm<FormValues>();
    const loggedinuser: any = useUserSelector();
    const commonApi: any = useCommonApi();
    const assetsApi: any = useAssetsApi();
    const facilityApi: any = useFacilitiesApi();
    const purchaseorderApi: any = usePurchaseOrderApi();
    const receiptApi = useReceiptApi();

    const [showLoader, setShowLoader] = React.useState<boolean>(false);
    const [facilityList, setFacilityList] = React.useState<Option[]>([]);
    const [receiptCode, setReceiptCode] = React.useState<string>(``);
    const [poattachments, setPoAttachments] = React.useState<FileList | null>(null);
    const [lastPoSearch, setLastPoSearch] = React.useState<any[]>([]);
    const [poDetails, setPoDetails] = React.useState<any>(null);
    const [lineItems, setLineItems] = React.useState<any[]>([]);

    const purchaseOrderID: any = watch(`purchaseOrderID`);

    const changeAttachmentHandler = (e: any) => {
        setPoAttachments(e.target.files);
    };

    const handlePOSearch = async (inputValue: string): Promise<any[]> => {
        return new Promise((resolve, reject) => {
            purchaseorderApi.getOrderList({
                pageSize: 50,
                pageNumber: 1,
                searchParam: (inputValue ? inputValue.trim() : inputValue),
                statusIDs: [3, 5].join(`,`)
            }, (resp: any) => {
                if (resp && resp.code === 200 && resp.hasOwnProperty('successful') && resp.successful === true && resp.hasOwnProperty('purchaseOrderList') && Array.isArray(resp.purchaseOrderList)) {
                    //resp.purchaseOrderList = resp.purchaseOrderList.filter((item:any) => item.hasOwnProperty(`statusID`) && +item.statusID === 3);
                    setLastPoSearch(resp.purchaseOrderList);
                    const options = resp.purchaseOrderList.map((item: any) => ({
                        label: item.purchaseOrderCode,
                        value: item.purchaseOrderID
                    }));
                    resolve(options);
                } else {
                    resolve([]);
                }
            }, (error: any) => {
                console.error("Error fetching Tasks", error);
                reject([]);
            });
        });
    };

    const processPODetails = async (purchaseOrderID: any) => {
        if (purchaseOrderID && purchaseOrderID.value) {
            const selectedPo = lastPoSearch.find(po => po.purchaseOrderID === purchaseOrderID.value);
            if (selectedPo) {
                bind_processPO(selectedPo);
                console.log("PO Details", poDetails);
            }
        }
    };

    const bind_processPO = async (selectedPo: any) => {
        const poDetails: any = await new Promise((resolve, reject) => {
            purchaseorderApi.getOrderById({ PurchaseOrderID: selectedPo.purchaseOrderID }, (resp: any) => {
                if (resp && resp.hasOwnProperty('purchaseOrderID') && resp.purchaseOrderID) {
                    //console.log("Selected PO Details", resp.purchaseOrder);
                    resolve(resp);
                } else {
                    resolve(null);
                }
            }, (error: any) => {
                console.error("Error fetching purchase order details", error);
                reject(error);
            });
        }).catch((error: any) => {
            return error;
        });
        if (poDetails) {
            /*
            {
                partsID: null,
                partCode: ``,
                PartName: ``,
                vendorPartCode: ``,
                unitCost: 0,
                unitCode: `Mm`,
                unitID: 18,
                orderedQty: 0,
                deliveredQty: 0,
                receivingQty: 0,
                totalValue: 0,        
            }
            */
            setValue(`facilityID`, { value: poDetails.facilityID, label: poDetails.facilityName });
            var bind_purchaseOrderItemList = [];
            if (poDetails.typeID === 1 && poDetails.hasOwnProperty(`purchaseOrderItemList`) && poDetails.purchaseOrderItemList && Array.isArray(poDetails.purchaseOrderItemList)) {
                bind_purchaseOrderItemList = poDetails.purchaseOrderItemList.map((item: any) => {
                    return {
                        partsID: item.partsID,
                        partsCode: item.partsCode,
                        partsName: item.partName,
                        vendorPartCode: item.vendorPartCode,
                        unitCost: item.unitPrice,
                        unitCode: item.unitCode,
                        unitID: item.unitID,
                        orderedQty: item.requiredQty,
                        deliveredQty: item.deliveredQty,
                        receivingQty: 0,
                        totalValue: 0,
                    }
                });
            }
            if ((poDetails.typeID === 2 || poDetails.typeID === 3) && poDetails.hasOwnProperty(`purchaseOrderAsset`) && poDetails.purchaseOrderAsset && Array.isArray(poDetails.purchaseOrderAsset)) {
                bind_purchaseOrderItemList = poDetails.purchaseOrderAsset.map((item: any) => {
                    return {
                        //assetID: item.assetID,
                        assetName: item.assetName,
                        unitID: item.unitID,
                        unitCode: item.unitCode,
                        unitCost: item.unitPrice,
                        orderedQty: item.requiredQty,
                        deliveredQty: item.deliveredQty,
                        receivingQty: 0,
                        totalValue: item.totalAmount
                    }
                });
            }
            poDetails[`bind_POItemList`] = bind_purchaseOrderItemList;
            setPoDetails(poDetails);
            setLineItems(bind_purchaseOrderItemList);
        }
    };

    const calculate_subtotal = () => {
        if (lineItems && lineItems.length > 0) {
            return lineItems.reduce((total, item) => {
                return total + (item.unitCost * item.receivingQty);
            }, 0);
        }
        return 0;
    };
    const calculate_grandtotal = () => {
        if (lineItems && lineItems.length > 0) {
            var subtotal = calculate_subtotal();
            if (poDetails && +poDetails.taxRate) {
                return subtotal + (+((subtotal * poDetails.taxRate) / 100).toFixed(2));
            }
            return subtotal;
        }
        return 0;
    };

    const onSubmit: SubmitHandler<FormValues> = async (data: any) => {
        console.log(data);
        console.log(lineItems);
        var payload: any = {
            receiptID: null,
            receiptCode: receiptCode,
            purchaseRequestID: poDetails.purchaseRequestID ? poDetails.purchaseRequestID : null,
            purchaseOrderID: poDetails ? poDetails.purchaseOrderID : null,
            purchaseOrderCode: data.purchaseOrderID?.label || null,
            facilityID: typeof data.facilityID !== undefined && data.facilityID && typeof data.facilityID === 'object' ? data.facilityID.value : null,
            subFacilityID: null,
            notes: data.notes || ``,
            receiptDate: moment().utc().toISOString(),
            vendorID: poDetails && poDetails.vendorID ? poDetails.vendorID : null,
            billComVendorID: poDetails && poDetails.billComVendorID ? poDetails.billComVendorID : null,
            billComDepartmentID: poDetails && poDetails.billComDepartmentID ? poDetails.billComDepartmentID : null,
            receiptPartsDetails: [],
            receiptAssetDetails: []
        };
        if (poDetails && !+poDetails.vendorID) {
            toast.error(`Vendor not set for this selected PO!`);
            return;
        }
        if (poDetails && +poDetails.typeID === 1 && lineItems.length > 0) {
            // Filter line items with receiving quantity greater than 0
            const itemsWithReceivingQty = lineItems.filter((item: any) => +item.receivingQty > 0);
            
            if (itemsWithReceivingQty.length === 0) {
                toast.error(`Please enter valid receiving quantity for at least one item!`);
                return;
            }

            const overloadqtydata = itemsWithReceivingQty.filter((item: any) => (+item.receivingQty + item.deliveredQty) > +item.orderedQty);
            if (overloadqtydata.length > 0) {
                if (window.confirm(`Receiving quantity + Delivered quantity is greater than ordered quantity! Are you sure you want to proceed?`)) {

                } else {
                    return;
                }
            }
            payload.receiptAssetDetails = [];
            payload.receiptPartsDetails = itemsWithReceivingQty.map((item: any) => {
                return {
                    partsID: item.partsID,
                    partsName: item.partsName,
                    partsCode: item.partsCode,
                    vendorPartCode: item.vendorPartCode,
                    orderedQuantity: item.orderedQty,
                    unitCost: item.unitCost,
                    unitID: item.unitID,
                    requiredQuantity: item.receivingQty,
                    totalCost: (item.receivingQty * item.unitCost),
                }
            });
        }
        if (poDetails && (+poDetails.typeID === 2 || +poDetails.typeID === 3) && lineItems.length > 0) {
            // Filter line items with receiving quantity greater than 0
            const itemsWithReceivingQty = lineItems.filter((item: any) => +item.receivingQty > 0);
            
            if (itemsWithReceivingQty.length === 0) {
                toast.error(`Please enter valid receiving quantity for at least one item!`);
                return;
            }

            const overloadqtydata = itemsWithReceivingQty.filter((item: any) => (+item.receivingQty + item.deliveredQty) > +item.orderedQty);
            if (overloadqtydata.length > 0) {
                if (window.confirm(`Receiving quantity + Delivered quantity is greater than ordered quantity! Are you sure you want to proceed?`)) {

                } else {
                    return;
                }
            }
            payload.receiptPartsDetails = [];
            payload.receiptAssetDetails = itemsWithReceivingQty.map((item: any) => {
                return {
                    //assetID: item.assetID,
                    assetName: item.assetName,
                    orderedQuantity: item.orderedQty,
                    unitCost: item.unitCost,
                    unitID: item.unitID,
                    receiveQuantity: item.receivingQty,
                    totalCost: (item.receivingQty * item.unitCost),
                }
            });
        }

        console.log("Here is the final payload", payload);
        setShowLoader(true);
        const receiptresp: any = await new Promise((resolve, reject) => {
            receiptApi.SavePurchaseRecipt(payload, (resp: any) => {
                resolve(resp);
            }, (error: any) => {
                console.error("Error creating receipt", error);
                toast.error(error?.message || "Failed to create receipt!");
                reject(error);
            });
        }).catch((error: any) => {
            setShowLoader(false);
            return null
        });
        setShowLoader(false);
        if (receiptresp && receiptresp.code === 200 && receiptresp.hasOwnProperty('successful') && receiptresp.successful === true && receiptresp.hasOwnProperty('returnID') && +receiptresp.returnID) {
            toast.success(receiptresp.message || `Receipt created successfully!`);

            if (poattachments && Array.isArray(poattachments) && poattachments.length > 0) {
                const formData = new FormData();
                formData.append(`ReceiptID`, receiptresp.returnID);
                var i = 0;
                for await (const file of poattachments) {
                    formData.append(`InputFile` + i, file);
                    i++;
                }
                const uploadresp: any = await new Promise((resolve, reject) => {
                    receiptApi.UploadAttachment(formData, (resp: any) => {
                        resolve(resp);
                    }, (error: any) => {
                        toast.error(error);
                        reject(error);
                    });
                }).catch((error: any) => { });
                if (uploadresp && uploadresp.code === 200 && uploadresp.hasOwnProperty('successful') && uploadresp.successful === true) {
                    toast.success(uploadresp?.message);
                } else {
                    toast.error(uploadresp?.message || "Failed to upload attachments!");
                }
            }
            setPoDetails(null);
            setLineItems([]);
            setReceiptCode(``);
            setPoAttachments(null);
            onCreate();
        } else {
            toast.error(receiptresp.message || `Failed to create receipt!`);
        }
        console.log("Receipt Response", receiptresp);
    };

    const init_page_data = async () => {
        setShowLoader(true);
        // Facility List
        const facilityresp = await new Promise((resolve, reject) => {
            facilityApi.getFacilityList({}, (resp: any) => {
                if (resp && resp.code === 200 && resp.hasOwnProperty('successful') && resp.successful === true && resp.hasOwnProperty('facilityList') && Array.isArray(resp.facilityList)) {
                    resp.facilityList = resp.facilityList.map((item: any) => {
                        return {
                            label: item.facilityName,
                            value: item.facilityID
                        };
                    })
                    resolve(resp.facilityList);
                } else {
                    reject([]);
                }
            }, (error: any) => {
                console.log("Facility list error", error);
                reject([]);
            });
        }).catch((error: any) => {
            return [];
        });
        setFacilityList(facilityresp as Array<Option>);

        const receiptcoderesp = await new Promise((resolve, reject) => {
            receiptApi.GetReciptCode({}, (resp: any) => {
                if (resp && resp.code) {
                    resolve(resp.code);
                } else {
                    reject(null);
                }
            }, (error: any) => {
                toast.error(`Failed to generate Receipt Code!`);
                reject(null);
            });
        }).catch((error: any) => {
            return null;
        });
        if (receiptcoderesp) {
            setReceiptCode(receiptcoderesp as string);
        }
        console.log("loggedinuser", loggedinuser);
        setShowLoader(false);

        if (po && po.purchaseOrderID) {
            setValue(`purchaseOrderID`, { value: po.purchaseOrderID, label: po.purchaseOrderCode });
            bind_processPO(po);            
        }
    };

    useEffect(() => {
        init_page_data();
    }, []);

    useEffect(() => {
        if (purchaseOrderID && purchaseOrderID.value) {
            setPoDetails(null);
            setTimeout(() => {
                processPODetails(purchaseOrderID);
            });
        } else {
            console.log("No purchase order selected");
            setPoDetails(null);
        }
    }, [purchaseOrderID]);

    console.log("poDetails.typeID", poDetails?.typeID);
    


    return (
        <div className={`relative`}>
            {showLoader && (
                <div className={`absolute p-8 w-full h-full z-[2px] bg-white bg-opacity-30`}>
                    <Loader />
                </div>
            )}
            <form onSubmit={handleSubmit(onSubmit)} className={`${showLoader ? `hidden` : `block`}`} noValidate>
                <div className='pt-4 min-h-[calc(100vh-160px)]'>
                    <div className='bg-green-50 py-2 px-3'>
                        <h6 className='text-[0.813rem] font-semibold'>Receipt ID</h6>
                        <p className='text-[0.813rem] font-normal mt-2'>{receiptCode}</p>
                    </div>
                    <div className={`grid grid-cols-2 gap-4`}>
                        <Controller
                            name={`purchaseOrderID`}
                            control={control}
                            rules={{ required: `Please select the Purchase Order to proceed.` }}
                            render={({ field: { value, onChange } }) => (
                                <SelectBox
                                    label='Select PO'
                                    value={value}
                                    onChange={onChange}
                                    required
                                    placeholder={`Type here to search PO`}
                                    options={[]}
                                    className='mb-0'
                                    isClearable={true}
                                    async={true}
                                    asyncLoadOptions={async (inputValue: string) => {
                                        return handlePOSearch(inputValue);
                                    }}
                                    error={errors.purchaseOrderID?.message}
                                />
                            )}
                        />
                        <Controller
                            name={`facilityID`}
                            control={control}
                            rules={{ required: `Please select the facility ID` }}
                            render={({ field: { value, onChange } }) => (
                                <SelectBox
                                    label='Select Facility'
                                    value={value}
                                    onChange={onChange}
                                    required
                                    placeholder='Select Facility'
                                    options={facilityList}
                                    className='mb-0'
                                    error={errors.facilityID?.message}
                                />
                            )}
                        />
                    </div>

                    {poDetails && (
                        <div>
                            {+poDetails.typeID === 1 && (
                                <CreateReceiptParts data={poDetails.bind_POItemList} onUpdate={setLineItems} />
                            )}
                            {+poDetails.typeID === 2 && (
                                <CreateReceiptAssets data={poDetails.bind_POItemList} onUpdate={setLineItems} />

                            )}
                            {+poDetails.typeID === 3 && (
                                <CreateReceiptAssets data={poDetails.bind_POItemList} onUpdate={setLineItems} />

                            )}
                        </div>
                    )}

                    {/*
                    <div className="ag-theme-alpine h-1/2">
                        <AgGridReact
                            columnDefs={columnDefs} // Pass columnDefs
                            rowData={rowData} // Pass rowData
                            pagination={false}
                            domLayout="autoHeight"
                        />
                    </div>
                    */}
                    {poDetails && (
                        <div className={``}>
                            <div className={`flex items-center justify-end gap-3 py-3 px-1 font-normal text-[15px] border-b border-[#043E6133] text-[#262A2D] h-12`}>
                                <div className={`text-right`}>Tax</div>
                                <div className={`w-28 text-right text-[#000000]`}><Currency currency={`USD`} value={(() => {
                                    return +((calculate_subtotal() * poDetails.taxRate) / 100).toFixed(2);
                                })()} /></div>
                            </div>
                            <div className={`flex items-center justify-end gap-3 py-3 px-1 font-normal text-[15px] border-b border-[#043E6133] text-[#262A2D] h-12`}>
                                <div className={`text-right`}>Grand Total</div>
                                <div className={`w-28 text-right text-[#000000]`}><Currency currency={`USD`} value={calculate_grandtotal()} /></div>
                            </div>
                            <div className={`flex items-center justify-end gap-3 py-3 px-1 font-normal text-[15px] border-b border-[#043E6133] text-[#262A2D] h-12`}>
                                <div className={`text-right`}>Receipt By</div>
                                <div className={`w-28 text-right`}>{loggedinuser?.firstName} {loggedinuser?.lastName}</div>
                            </div>
                            <div className={`flex items-center justify-end gap-3 py-3 px-1 font-normal text-[15px] text-[#262A2D] h-12`}>
                                <div className={`text-right`}>Receipt Date</div>
                                <div className={`w-28 text-right`}>{moment().format('MM/DD/YY')}</div>
                            </div>
                        </div>
                    )}

                    <Controller
                        name={`notes`}
                        control={control}
                        /*rules={{ required: `Please enter your notes` }}*/
                        render={({ field: { value, onChange } }) => (
                            <Teaxtarea
                                label='Notes'
                                value={value}
                                onChange={onChange}
                                /*required*/
                                placeholder='Write Your Notes'
                                error={errors.notes?.message}
                                className='!my-3'
                            />
                        )}
                    />
                    <Controller
                        name="receiptFiles"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <FileUpload
                                label="Upload Bill of Lading/Attachment"
                                value={value}
                                isMulti={true}
                                accept=".jpg, .jpeg, .png, .pdf"
                                isFigmaType={true}
                                allowedExt={[`png`, `jpg`, `jpeg`, `gif`, `pdf`]}
                                retainFiles={true}
                                maxSize={6}
                                onChange={(e: any, files: any) => {
                                    changeAttachmentHandler(e);
                                    onChange(e.target.files[0]);
                                }}
                                placeholder="Choose Processing Facility"
                                className='!my-4'
                            />
                        )}
                    />
                </div>
                <div className={`sticky bottom-0 bg-white z-[1px]`}>
                    <hr className={`border-gray-900 my-4 sticky z-[1px] bottom-6`} />
                    <div className={`flex justify-end gap-2`}>
                        <Button type={`submit`} childstyle={{ paddingLeft: `15px`, paddingRight: `15px` }}>Save</Button>
                        <Button theme='secondary' onClick={() => {
                            onCancel();
                        }}>Cancel</Button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default CreateFacilities;